import { useEffect } from 'react'
import ReactGA from 'react-ga'
import { useLocation } from 'react-router'

const GoogleAnalytics = (): null => {
  const location = useLocation()

  useEffect(() => {
    const page = location.pathname + location.search
    const windowLocation = window.location
    ReactGA.set({
      page,
      location: `${windowLocation.origin}${page}`,
    })
    ReactGA.pageview(page)
  }, [location.pathname, location.search])

  return null
}

export const RouteTracker = (): JSX.Element => <GoogleAnalytics />
